import React from "react";

const ASP_Global_asa = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Global asa</h1>
      <p>This is the ASP Global asa page content.</p>
    </div>
  );
};

export default ASP_Global_asa;
